import type { FC } from 'react';
import type { SmallMenuItem } from '@/types/menu';
import { LinkWrapper } from '@/components/LinkWrapper';

import styles from './styles.module.css';

export const MegaMenuLinkWrapper: FC<{ child: SmallMenuItem }> = ({
	child,
}) => (
	<LinkWrapper
		className={styles.menuSectionsListItemSubmenuLink}
		href={child.url}
		key={child.id}
	>
		{child.text}
	</LinkWrapper>
);
